<div class="no-banner" *ngIf="banners?.length == 0">
  <img alt="banner" src="/assets/images/home-banner.png" />
</div>

<div class="slider-section sliderbanner custon-slick-dots" id="homeBannerSliderWrapper" *ngIf="banners?.length > 0">
  <ngx-slick-carousel class="carousel m-0 container p-0" id="homeBannerSlider" #slickController="slick-carousel" [config]="homeBannerSlider">
    <div ngxSlickItem class="slide" *ngFor="let item of banners">
      <a *ngIf="item.link" [href]="item.link" target="_blank">
        <img class="main-image" [src]="item.fileName" [alt]="item.name" />
        <div class="slide-container">
          <div class="container">
            <div [ngSwitch]="item.textAlignment">
              <div *ngSwitchCase="bannerAlignments.left">
                <div class="slide-data-inner">
                  <div class="banner-slide-logo" *ngIf="item.logoName">
                    <img alt="logo" [src]="item.logoName" />
                  </div>
                  <div *ngIf="item.description" class="slide-content" [innerHTML]="item.description | sanitizedHtml">
                  </div>
                </div>
              </div>

              <div class="textBannerRight" *ngSwitchCase="bannerAlignments.right">
                <div class="slide-data-inner">
                  <div class="banner-slide-logo" *ngIf="item.logoName">
                    <img alt="logo" [src]="item.logoName" />
                  </div>
                  <div *ngIf="item.description" class="slide-content" [innerHTML]="item.description | sanitizedHtml">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </a>
      <div *ngIf="!item.link">
        <img class="main-image" [src]="item.fileName" [alt]="item.name" />
        <div class="slide-container">
          <div class="container">
            <div [ngSwitch]="item.textAlignment">
              <div *ngSwitchCase="bannerAlignments.left">
                <div class="slide-data-inner">
                  <div class="banner-slide-logo" *ngIf="item.logoName">
                    <img alt="logo" [src]="item.logoName" />
                  </div>
                  <div *ngIf="item.description" class="slide-content" [innerHTML]="item.description | sanitizedHtml">
                  </div>
                </div>
              </div>

              <div class="textBannerRight" *ngSwitchCase="bannerAlignments.right">
                <div class="slide-data-inner">
                  <div class="banner-slide-logo" *ngIf="item.logoName">
                    <img alt="logo" [src]="item.logoName" />
                  </div>
                  <div *ngIf="item.description" class="slide-content" [innerHTML]="item.description | sanitizedHtml">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ngx-slick-carousel>

  <div class="pausePlayBtns d-none">
    <span class="cursor-pointer" role="button" (click)="slickController.slickPlay()">
      <img alt="playIcon" class="playIcon" src="assets/images/playSlider.svg" />
    </span>
    <span class="cursor-pointer" role="button" (click)="slickController.slickPause()">
      <img alt="playIcon" class="playIcon" src="assets/images/pauseSlider.svg" />
    </span>
  </div>
</div>

<section class="serivces-section home-services">
  <div class="homepage-top-title-content">
    <h2 class="homepage-top-title-content-header">Your Trusted Asset Solutions Partner</h2>
    <h3>Global Valuation and Liquidation Service Provider</h3>
  </div>
  <div class="container">
    <!-- <h2 class="services-heading">Our Services</h2> -->
    <div class="gutter-xxl-24 view-our-services-wrap">
      <div class="col-12 col-md-4">
        <div role="button" class="shadow-card cursor-pointer" [routerLink]="[routes.currentAuction]">
          <div class="img-wrap">
            <img alt="used-assets" class="img-fluid img-border" src="assets/images/viewCalAuction.png" />
            <div class="over-text">
              <!-- <h3 class="name">Buy <span>Assets</span></h3> -->
              <p class="hover-text">
                Purchase quality new and used industrial assets.
              </p>
            </div>
            <div class="btn-box">
              <button class="btn btn-colored">
                VIEW AUCTION <br>
                CALENDAR
                <!-- <img alt="icon" src="assets/images/right-arrow.svg" /> -->
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="shadow-card cursor-pointer" [routerLink]="[routes.sellers]">
          <div class="img-wrap">
            <img alt="sell-assets" class="img-fluid img-border" src="assets/images/sellUsedEquip.png" />
            <div class="over-text">
              <!-- <h3 class="name">Sell <span>Assets</span></h3> -->
              <p class="hover-text">
                Our knowledge and industry expertise will help you reach your
                liquidation goals.
              </p>
            </div>
            <div class="btn-box">
              <button class="btn btn-colored">
                SELL USED <br>
                EQUIPMENT
                <!-- <img alt="icon" src="assets/images/right-arrow.svg" /> -->
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="shadow-card cursor-pointer" [routerLink]="[routes.valuations]">
          <div class="img-wrap">
            <img alt="value" class="img-fluid img-border" src="assets/images/valueYourEquip.png" />
            <div class="over-text">
              <!-- <h3 class="name">Value <span>Assets</span></h3> -->
              <p class="hover-text">
                Our accredited appraisers provide accurate machinery & equipment
                and inventory valuations.
              </p>
            </div>
            <div class="btn-box">
              <button class="btn btn-colored">
                VALUE YOUR <br>
                EQUIPMENT
                <!-- <img alt="icon" src="assets/images/right-arrow.svg" /> -->
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="vos-link-wrapper">
        <a [routerLink]="[routes.about]">View Our Services >></a>
      </div>
    </div>
  </div>
</section>

<section class="upcoming-actions upcoming" *ngIf="upcomingAuctions.length > 0">
  <div class="container">
    <div class="content">
      <h2 class="">Upcoming Auctions</h2>
      <button type="button" class="calendar-btn" [routerLink]="[routes.currentAuction]">
        View All Upcoming Auction Events
      </button>
    </div>
    <div class="row gutter-16 justify-content-center">
      <div class="col-12 col-md-6 col-lg-4" *ngFor="let item of upcomingAuctions">
        <auction-card [auctionData]="item" [routeType]="'auctions'"></auction-card>
      </div>
    </div>

    <div class="row">
      <div class="col-12 text-center pt-4">
        <button type="button" class="btn btn-colored calendar-btn-Bottom" [routerLink]="[routes.currentAuction]">
          View All Upcoming Auction Events
        </button>
      </div>
    </div>
  </div>

  <section class="mt-30 featured-past-section" *ngIf="featuredPastAuctions?.length > 0">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h2 class="services-heading">Featured Past Auctions</h2>
        </div>
      </div>

      <div class="warehouse-slider-wrap custon-slick-dots">
        <ngx-slick-carousel class="carousel" [config]="featuredPastSlider">
          <div ngxSlickItem class="slide" *ngFor="let item of featuredPastAuctions">
            <div class="warehouse-slide-outer">
              <div class="warehouse-slide">
                <div class="top">
                  <img alt="cover photo" class="img-fluid" AuctionDefaultImage *ngIf="item" [image]="item.coverPhoto" />
                  <div class="home-card-logo">
                    <img class="img-fluid" alt="clientLogo" AuctionDefaultImage *ngIf="item" [image]="item.clientLogo" />
                  </div>
                </div>
                <div class="btm">
                  <h1 class="name" [innerHTML]="item.tagline | sanitizedHtml"></h1>
                  <ng-container *ngIf="
                      item.saleType.isDetailPageInHouse;
                      else redirectLinkButton
                    ">
                    <a class="view-details" [routerLink]="item.auctionCode">
                      View Details
                      <img alt="arrow" src="../assets/images/arrow_right.svg" />
                    </a>
                  </ng-container>
                  <ng-template #redirectLinkButton>
                    <a [ngClass]="{ 'disabled-link': !item.detailPageLinkUrl }" class="view-details"
                      [href]="item.detailPageLinkUrl" target="_blank">
                      View Details
                      <img alt="arrow" src="../assets/images/arrow_right.svg" />
                    </a>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </ngx-slick-carousel>
      </div>

      <div class="row">
        <div class="col-12 view-all text-center">
          <a role="button" class="btn btn-colored calendar-btn-Bottom" href="/featured-past">View All Recent Auctions</a>
        </div>
      </div>
    </div>
  </section>

</section>

<section class="subscribe-section">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="content">
          <h2>Stay In The Know</h2>
          <p>Receive new auction alerts, machinery marketplace deals & more</p>
          <div class="email-box">
            <input type="email" id="sub-home-input" placeholder="Enter Email Address" [formControl]="emailSubscription"
              [maxLength]="maxlengthShorter" />
            <button type="button" [disabled]="emailSubscription.invalid" role="button"
              (click)="openModal(subscribeModal)">
              Subscribe
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="industrial-warehouse" *ngIf="upcomingMachineryAuctions?.length > 0">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h2 class="services-heading">Industrial Surplus Warehouse</h2>
      </div>
    </div>

    <div class="warehouse-slider-wrap custon-slick-dots">
      <ngx-slick-carousel class="carousel" [config]="warehouseSlider">
        <div ngxSlickItem class="slide" *ngFor="let item of upcomingMachineryAuctions">
          <div class="warehouse-slide-outer">
            <div class="warehouse-slide">
              <div class="top">
                <img alt="cover photo" class="img-fluid" AuctionDefaultImage *ngIf="item" [image]="item.coverPhoto" />
                <p class="slide-des">{{ item.title }}</p>
              </div>
              <div class="btm">
                <h1 class="name" [innerHTML]="item.tagline | sanitizedHtml"></h1>
                <p class="des">Available For Immediate Sale</p>
                <ng-container *ngIf="
                    item.saleType.isDetailPageInHouse;
                    else redirectLinkButton
                  ">
                  <a class="view-details" [routerLink]="item.auctionCode">
                    View Details
                    <img alt="arrow" src="../assets/images/arrow_right.svg" />
                  </a>
                </ng-container>
                <ng-template #redirectLinkButton>
                  <a [ngClass]="{ 'disabled-link': !item.detailPageLinkUrl }" class="view-details"
                    [href]="item.detailPageLinkUrl" target="_blank">
                    View Details
                    <img alt="arrow" src="../assets/images/arrow_right.svg" />
                  </a>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </ngx-slick-carousel>
    </div>

    <div class="row">
      <div class="col-12 view-all text-center">
        <a role="button" class="btn btn-white-border" target="_blank" href="https://bgisurplus.com">See More Items at BG
          Industrial Surplus</a>
      </div>
    </div>
  </div>
</section>


<section class="awards">
  <h2 class="page-heading">Industry Accreditations & Memberships</h2>
  <div class="container">
    <ngx-slick-carousel class="carousel awards-list" [config]="awardsSlider">
      <div ngxSlickItem class="slide">
        <div class="awards-list-item">
          <img alt="ASA, American Society of Appraisers" src="../assets/images/awards1.png" />
        </div>
      </div>
      <div ngxSlickItem class="slide">
        <div class="awards-list-item">
          <img alt="Industrial Auctioneers Association" src="../assets/images/awards2.png" />
        </div>
      </div>
      <div ngxSlickItem class="slide">
        <div class="awards-list-item">
          <img alt="ACG, Association for Corporate Growth" src="../assets/images/awards3.png" />
        </div>
      </div>
      <div ngxSlickItem class="slide">
        <div class="awards-list-item">
          <img alt="Secured Finance Network" src="../assets/images/awards4.png" />
        </div>
      </div>
      <div ngxSlickItem class="slide">
        <div class="awards-list-item">
          <img alt="AMEA, Association of Machinery and Equipment Appraisers" src="../assets/images/awards5.png" />
        </div>
      </div>
      <div ngxSlickItem class="slide">
        <div class="awards-list-item">
          <img alt="MDNA, Machinery Dealers National Association" src="../assets/images/mdna-logo.png" />
        </div>
      </div>
      <div ngxSlickItem class="slide">
        <div class="awards-list-item">
          <img alt="TMA, Turnabout Management Association" src="../assets/images/tma-logo.png" />
        </div>
      </div>
      <div ngxSlickItem class="slide">
        <div class="awards-list-item">
          <img alt="NAA, National Auctioneers Association" src="../assets/images/naa_logo.jpg" />
        </div>
      </div>
      <div ngxSlickItem class="slide">
        <div class="awards-list-item">
          <img alt="Better Business Bureau Accredited Business" src="../assets/images/bbb_logo.png" />
        </div>
      </div>
      <div ngxSlickItem class="slide">
        <div class="awards-list-item">
          <img alt="Investment Recovery Association" src="../assets/images/IRA_logo.jpg" />
        </div>
      </div>
    </ngx-slick-carousel>
  </div>
</section>

<ng-template #subscribeModal>
  <div class="modal-header pb-0">
    <h4 class="modal-title pull-left">&nbsp;</h4>
    <button type="button" class="close pull-right circle-icon" aria-label="Close" role="button" (click)="closeModal()">
      <img alt="close-icon" src="../assets/images/cross.svg" />
    </button>
  </div>
  <div class="modal-body">
    <div class="modal-body" id="subscribeModal-body-home"></div>
  </div>
</ng-template>
